module.exports = __webpack_public_path__ + "img/Prenatal.62f22f76.png";